import {breakpoint} from "../layout/common";

export let H2 = ({children, centered = true}) => {
    return <h2 className={`h2 ${centered ? 'text-center' : ''} mb-4 mb-${breakpoint}-4`}>
        {children}
    </h2>
}